/**
 * 실행 환경 판정 — 태블릿 브릿지앱(ZlzlKiosk WebView)인가, 일반 웹 브라우저인가.
 *
 * 🔴 이 판정의 **단일 출처**다. 예전에는 같은 비교가 3곳에 흩어져 있었고
 *    (`useVersionCheck.js` / `QuestManualCheckPage.jsx` / `ServiceMenuPage.jsx`),
 *    전체화면 게이트 5곳을 붙이면 8곳이 될 참이었다. UA 토큰이 바뀌는 날 전부 찾아야 하므로
 *    여기로 모았다. **`ZlzlKiosk/` 리터럴은 이 파일에만 둔다.**
 *
 * 판정 기준: 브릿지앱이 WebView UA 에 `ZlzlKiosk/<version>` 토큰을 덧붙인다.
 *
 * fail-safe 방향: **모르면 웹으로 본다.** 웹으로 오판하면 전체화면이 안 되는 정도지만,
 * 앱으로 오판하면 일반 크롬에서 갑자기 전체화면이 되어 빠져나오는 법을 모르게 된다.
 *
 * 계약 고정: `tools/src/utils/isBridgeApp.test.js`
 *
 * @param {string} [userAgent] 생략 시 `navigator.userAgent` (SSR·테스트 대비 방어)
 * @returns {boolean}
 */
export function isBridgeApp(userAgent) {
  const resolvedUserAgent =
    userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : '');
  return resolvedUserAgent.includes('ZlzlKiosk/');
}

export default isBridgeApp;
